<template>
  <v-lazy style="overflow: hidden" width="100%" :height="height ? height : '300px'">
    <l-map
      ref="myMap"
      :style="'height:' + (height ? height + 'px' : '300px')"
      :options="options"
      :zoom="zoom"
      :center="centerMap"
    >
      <l-tile-layer :url="url" :attribution="attribution" />
      <l-marker v-for="marker in markers" :key="marker.name" :lat-lng="marker">
        <l-popup>
          <div>{{ marker.name }}</div>
          <div>{{ marker.lat + ' ' + marker.lng }}</div>
        </l-popup>
      </l-marker>
      <l-control position="bottomright">
        <button class="map-centered" @click="onGoMarker">
          <IconsMap icon="map-center" />
        </button>
      </l-control>
    </l-map>
  </v-lazy>
</template>

<script>
import IconsMap from 'components/icons/map/IconsMap'
export default {
  name: 'Map',
  components: { IconsMap },
  props: {
    height: [String, Number],
    markers: [Object, Array],
    options: {
      // https://vue2-leaflet.netlify.app/components/LMap.html#demo
      type: Object,
      default: () => ({
        doubleClickZoom: 'center',
      }),
    },
    center: Array,
  },
  data: () => ({
    url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
    attribution: '<a target="_blank" href="https://proapp.fi/">ProApp</a>',
    zoom: 15,
  }),
  computed: {
    centerMap() {
      if (this.center) {
        return this.center
      } else {
        let marker = this.markers[this.markers.length - 1]
        return [marker.lat, marker.lng]
      }
    },
  },
  methods: {
    onGoMarker() {
      this.$refs.myMap.mapObject.panTo(this.center)
    },
  },
}
</script>

<style lang="scss">
.leaflet-bottom {
  .leaflet-control-attribution {
    display: none;
  }
}
.map {
  &-centered {
    background: #ffffff;
    width: 34px;
    height: 34px;
    display: flex;
    justify-content: center;
    align-items: center;
    svg {
      width: 80%;
      height: auto;
      path {
        fill: #1976d2;
      }
    }
    &:hover {
      background-color: #f4f4f4;
      svg {
        path {
          fill: black;
        }
      }
    }
  }
}
</style>
